(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["otg-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('otg-delivery-estimate')) return;

    class OtgDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        this.variantId = this.form?.elements.namedItem('id')?.value || this.dataset.variant;
        this.eligibleVariants = new Set(this.dataset.eligibleVariants.split(',').filter(Boolean));
        this.onVariantChange = (event) => {
          this.variantId = String(event.detail.variant?.id || '');
          this.update();
        };
        this.onRefresh = () => this.update();
        this.form?.addEventListener('variant:change', this.onVariantChange);
        this.form?.addEventListener('change', this.onRefresh);
        document.addEventListener('visibilitychange', this.onRefresh);
        window.addEventListener('pageshow', this.onRefresh);
        this.interval = window.setInterval(this.onRefresh, 60000);
        this.update();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:change', this.onVariantChange);
        this.form?.removeEventListener('change', this.onRefresh);
        document.removeEventListener('visibilitychange', this.onRefresh);
        window.removeEventListener('pageshow', this.onRefresh);
        window.clearInterval(this.interval);
      }

      update() {
        const sellingPlan = this.form?.elements.namedItem('selling_plan')?.value;
        if (!this.eligibleVariants.has(this.variantId) || sellingPlan) {
          this.hidden = true;
          return;
        }
        try {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timeZone, year: 'numeric', month: 'numeric', day: 'numeric'
          }).formatToParts(new Date());
          const part = (name) => Number(parts.find((item) => item.type === name).value);
          const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
          const min = Number(this.dataset.minDays);
          const max = Number(this.dataset.maxDays);
          if (!Number.isInteger(min) || !Number.isInteger(max) || min < 1 || max < min || max > 60) {
            this.hidden = true;
            return;
          }
          const addDays = (count) => {
            const date = new Date(today);
            for (let added = 0; added < count;) {
              date.setUTCDate(date.getUTCDate() + 1);
              if (this.dataset.dayType !== 'business' || (date.getUTCDay() !== 0 && date.getUTCDay() !== 6)) added++;
            }
            return date;
          };
          const start = addDays(min);
          const end = addDays(max);
          const format = new Intl.DateTimeFormat(this.dataset.locale || 'en-US', {
            timeZone: 'UTC', month: 'short', day: 'numeric',
            ...(end.getUTCFullYear() !== today.getUTCFullYear() ? { year: 'numeric' } : {})
          });
          [[this.querySelector('[data-delivery-start]'), start], [this.querySelector('[data-delivery-end]'), end]].forEach(([element, date]) => {
            element.dateTime = date.toISOString().slice(0, 10);
            element.textContent = format.format(date);
          });
          this.hidden = false;
        } catch {
          this.hidden = true;
        }
      }
    }

    customElements.define('otg-delivery-estimate', OtgDeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

})();
